// import { ElMessage } from 'element-plus'
import { isClient } from '@/utils/is/index'
export default {
  info: async (msg: string) => {
    if (isClient()) {
      const { ElMessage } = await import('element-plus')
      ElMessage.info(msg)
    }
  },
  error: async (msg: string) => {
    if (isClient()) {
      const { ElMessage } = await import('element-plus')
      ElMessage.error(msg)
    }
  },
  success: async (msg: string) => {
    if (isClient()) {
      const { ElMessage } = await import('element-plus')
      ElMessage.success(msg)
    }
  },
  warning: async (msg: string) => {
    if (isClient()) {
      const { ElMessage } = await import('element-plus')
      ElMessage.warning(msg)
    }
  }
}
